import { Component, Input, OnChanges, OnInit, Output, SimpleChanges,EventEmitter } from '@angular/core';
import { Router,  NavigationEnd, ResolveEnd } from "@angular/router";
import { filter } from 'rxjs/operators';
import { ApprovalsMenuItem } from '@core/models/menu-item.model';

@Component({
    selector: 'core-helpers-navigation-vertical-tabs-approvals-status',
    templateUrl: './vertical-tabs-approvals-status.component.html',
    styleUrls: ['./vertical-tabs-approvals-status.component.scss']
})
export class HelperNavigationVerticalTabsApprovalsStatusComponent implements OnInit, OnChanges {
    public currentRoute: string;
    public ShowNavOptions: boolean;
    
    @Input() menu: ApprovalsMenuItem[];
    @Input() fullMatch: boolean = true;
    @Output() menuClick = new EventEmitter<ApprovalsMenuItem>();

    public showNavOptions: boolean;

    public menuItems: ApprovalsMenuItem[];

    constructor(private router: Router){
        this.router.events.pipe(
            filter(event => (event instanceof NavigationEnd || event instanceof ResolveEnd) )
        ).subscribe((event: any) => {
            // console.log("URL dashboard ---->", event);
            this.currentRoute = event.url;

        });
    }

    ngOnInit(){
        this.menuItems = this.menu;
        this.currentRoute = this.router.url;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.menu){
            // console.log(" MENU UPDATED!!!! ",changes.menu);
            this.menuItems = this.menu;
        }
    }

    onClick(item: ApprovalsMenuItem, event: any) {
        // console.log(" GOING TO "+item)
        this.menuClick.emit(item);
        // console.log(" GOING event ",event)
        event.stopPropagation();

    }

}
